module.exports = __webpack_public_path__ + "img/Step7.fd3fe18f.png";